// src/pages/Home.js
import Hero from '../components/sections/Hero';
import About from '../components/sections/About';
import Expertise from '../components/sections/Expertise';
import Portfolio from '../components/sections/Portfolio';
import Testimonials from '../components/sections/Testimonials';
import Whyus from '../components/sections/Whyus.js';
// import Insights from '../components/sections/Insights.js';
import CTA from '../components/sections/CTA.js';
import Contact from '../components/sections/Contact.js';

const Home = () => {

  return (
    <>
      <Hero />
      <About />
      <Expertise />
      <Portfolio />
      <Whyus />
      <Testimonials />
      {/* <Insights /> */}
      <CTA />
      <Contact />
    </>
  );
};

export default Home;